import type { ReactNode } from 'react';

type PageMainProps = {
  children: ReactNode;
  className?: string;
  width?: 'default' | 'narrow';
};

export function PageMain({ children, className = '', width = 'default' }: PageMainProps) {
  const maxWidth = width === 'narrow' ? 'max-w-4xl' : 'max-w-6xl';
  return (
    <main id="main-content" className={`${maxWidth} mx-auto px-4 pt-0 pb-12 ${className}`}>
      {children}
    </main>
  );
}

type PageHeaderProps = {
  title: string;
  subtitle?: string;
  className?: string;
};

export function PageHeader({ title, subtitle, className = 'mb-8' }: PageHeaderProps) {
  return (
    <div className={`page-header ${className}`}>
      <h1 className="text-3xl mb-2">{title}</h1>
      {subtitle ? <p className="dim text-sm">{subtitle}</p> : null}
    </div>
  );
}
